'use strict';

const AngularHelpers=require('../../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.emiratesReport',
dependencies:['ui.router'],
configs:[
require('./emiratesReportConfig')],

components:[
require('./emiratesReportController')]});
//# sourceMappingURL=index.js.map
